import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeAsterisk'
})
export class RemoveAsterisk implements PipeTransform {
  transform(value: string): unknown {
    const noAsteriskValue = value.replace('*', '');
    return noAsteriskValue;
  }
}
